import React from 'react';
import styled from 'styled-components';
import { ColorRing } from 'react-loader-spinner';
import { Typography } from '@mui/material';

const SplashScreenContainer = styled.div`
  min-height: 100vh;
  min-width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2rem;

  img {
    max-width: 200px;
  }
`;

export const SplashScreen = () => {
  return (
    <SplashScreenContainer>
      <img src={process.env.REACT_APP_APP_URL + "images/logo.png"} alt="Logo Dia das Crianças Eskala - Diversão Surpresa" />
      <ColorRing
        visible={true}
        height="80"
        width="80"
        ariaLabel="blocks-loading"
        wrapperStyle={{}}
        wrapperClass="blocks-wrapper"
        colors={['#D02C71', '#FCC00D', '#7BBA3F', '#674897', '#78909C']}
      />
      <Typography variant='h6' className='dark--text'>
        carregando...
      </Typography>
    </SplashScreenContainer>
  )
}
